// New channel and New category (#141, #154): the Chats list and the IRC window list have no categories to put a + on,
// so owners and admins make them from the server menu.
import { useEffect, useState } from "react";
import type { Category } from "@bloom/shared";

export function NewChannelDialog({ kind, categories, onCreate, onClose }: {
  kind: "channel" | "category";
  categories: Category[];
  /** Resolves to an error message, or null once it's made. */
  onCreate: (name: string, categoryId: string | null) => Promise<string | null>;
  onClose: () => void;
}) {
  const [name, setName] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== "Escape") return;
      e.preventDefault();
      onClose();
    };
    document.addEventListener("keydown", onKey, true);
    return () => document.removeEventListener("keydown", onKey, true);
  }, []);
  const noun = kind === "channel" ? "channel" : "category";
  return (
    <div className="overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <form
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="nc-title"
        style={{ maxWidth: 400 }}
        onSubmit={async (e) => {
          e.preventDefault();
          if (!name.trim() || busy) return;
          setBusy(true);
          const problem = await onCreate(name, kind === "channel" && categoryId ? categoryId : null);
          setBusy(false);
          if (problem) setError(problem);
          else onClose();
        }}
      >
        <h2 id="nc-title">New {noun}</h2>
        <div className="field">
          <label htmlFor="nc-name">Name</label>
          <input id="nc-name" className="input" autoFocus value={name} maxLength={40} placeholder={kind === "channel" ? "new-channel" : "Category name"} onChange={(e) => setName(e.target.value)} />
        </div>
        {kind === "channel" && categories.length > 0 && (
          <div className="field">
            <label htmlFor="nc-cat">Category</label>
            <select id="nc-cat" className="input" value={categoryId} onChange={(e) => setCategoryId(e.target.value)}>
              <option value="">None</option>
              {[...categories].sort((a, b) => a.position - b.position).map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
        )}
        {error && <div className="error" role="alert">{error}</div>}
        <div className="confirm-actions">
          <button type="button" className="btn" onClick={onClose}>Cancel</button>
          <button type="submit" className="btn btn-primary" disabled={!name.trim() || busy}>Create</button>
        </div>
      </form>
    </div>
  );
}
